var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4003",
    "data-name": "Rectangle 4003",
    width: 24,
    height: 24,
    transform: "translate(589 534)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calender",
    transform: "translate(-589 -534)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7654",
    "data-name": "Group 7654",
    transform: "translate(592.018 536.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7653",
    "data-name": "Group 7653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8253",
    "data-name": "Path 8253",
    d: "M0,4.076a6.164,6.164,0,0,1,.306-.951A2.855,2.855,0,0,1,2.849,1.474c.328-.018.658,0,1.006,0,0-.237,0-.455,0-.673A.736.736,0,1,1,5.324.791c0,.219,0,.438,0,.667H8.63c0-.244-.008-.492,0-.739a.732.732,0,0,1,1.464,0c0,.122,0,.245,0,.367s0,.232,0,.363H13.44c0-.244-.009-.492,0-.74a.729.729,0,0,1,1.12-.6.716.716,0,0,1,.344.632c0,.232,0,.464,0,.721a8.486,8.486,0,0,1,.864.006,5.076,5.076,0,0,1,1.112.19A2.893,2.893,0,0,1,18.794,4.29c.011.342,0,.685,0,1.028q0,3.387,0,6.774a.793.793,0,0,1-.236.632.7.7,0,0,1-.767.147.707.707,0,0,1-.462-.611,1.942,1.942,0,0,1-.006-.238q0-3.754,0-7.508a1.479,1.479,0,0,0-1.374-1.562c-.34-.023-.683-.006-1.052-.006,0,.251.009.5,0,.748a.729.729,0,0,1-1.12.6.716.716,0,0,1-.344-.632c0-.232,0-.464,0-.709H10.1c0,.219,0,.437,0,.656A.737.737,0,1,1,8.629,3.6c0-.213,0-.426,0-.65h-3.3c0,.225,0,.444,0,.663a.736.736,0,1,1-1.468,0c0-.219,0-.437,0-.677a3.785,3.785,0,0,0-1.549.153A1.446,1.446,0,0,0,1.47,4.465c-.006.606,0,1.212,0,1.817q0,4.736,0,9.473A1.433,1.433,0,0,0,2.3,17.168a1.8,1.8,0,0,0,.743.156q6.352.014,12.7.006a1.476,1.476,0,0,0,1.584-1.473.722.722,0,0,1,.493-.685.732.732,0,0,1,.975.723,2.938,2.938,0,0,1-1.871,2.7c-.238.088-.49.139-.735.206H2.607a.39.39,0,0,0-.082-.033A2.853,2.853,0,0,1,.289,17.107,6.55,6.55,0,0,1,0,16.192V4.076",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M222.727,223.2c0-.306-.017-.613,0-.917a1.415,1.415,0,0,1,1.342-1.378,15.271,15.271,0,0,1,1.962,0,1.42,1.42,0,0,1,1.346,1.432q.025.88,0,1.762a1.42,1.42,0,0,1-1.345,1.433,15.021,15.021,0,0,1-1.962,0,1.432,1.432,0,0,1-1.35-1.469c-.006-.287,0-.575,0-.863h0m1.476.867h1.7v-1.708h-1.7Z",
    transform: "translate(-212.478 -210.713)",
    fill: "#0a64f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.2b4740385a3f973ca6ab8ef0c1fca6e7.svg";
export { ForwardRef as ReactComponent };